import { NgModule } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { StockChartComponent } from './stock-chart.component';
import { AppComponentsSharedModule } from '../app-components.shared.module';

@NgModule({
  imports: [
    JssModule.forChild(StockChartComponent),
    AppComponentsSharedModule
  ],
  declarations: [
    StockChartComponent
  ],
})
export class StockChartModule { }
